import { BaseStateMiddleware, IAttachmentHandler, IMiddlewareConfig } from 'smarthub-common'
import {
  AttachmentCollection as Collection,
  createAttachmentMiddleware as createMiddleware,
} from 'smarthub-core'
import {
  coreAttachmentMiddleware as core,
} from 'smarthub-components'

export const attachmentMiddleware = (): IMiddlewareConfig<
  BaseStateMiddleware,
  IAttachmentHandler
> => {
  const collection = new Collection()
  const middleware = createMiddleware(core, collection.middleware)
  return {
    middleware,
    collection,
  }
}
